module.exports = __webpack_public_path__ + "img/remaining_carn.7245c42d.png";